import SearchIcon from "@mui/icons-material/Search";
import { IconButton, InputAdornment, TextField } from "@mui/material";
import { useContext } from "react";

import { Language } from "@/model/Language/Language";

import { TranslationContext } from "@/app/providers";

import { GetLanguageValueAsString } from "@/app/application/Translate";


type Props = {
	searchParams: string;
	setSearchParams: (value: string) => void;
	disabled?: boolean;
	placeholder?: string;
};

const SearchBar = ({
	searchParams,
	setSearchParams,
	disabled = false,
	placeholder = "Search…",
}: Props) => {
	const translation: Language | null = useContext(TranslationContext);
	return (
		<TextField
			id="search"
			size="small"
			placeholder={placeholder}
			value={searchParams}
			onChange={(e) => setSearchParams(e.target.value)}
			disabled={disabled}
			sx={{ flex: 1, minWidth: 260 }}
			InputProps={{
				startAdornment: (
					<InputAdornment position="start">
						<SearchIcon fontSize="small" />
					</InputAdornment>
				),
				endAdornment: !!searchParams && !disabled && (
					<InputAdornment position="end">
						<IconButton
							aria-label={GetLanguageValueAsString(translation, "Auto.Shared.Ui.SearchBar.Index.L35C19.ClearSearch", "Clear search")}
							onClick={() => setSearchParams("")}
							size="small"
						>
							<span aria-hidden>✕</span>
						</IconButton>
					</InputAdornment>
				),
			}}
			inputProps={{ "aria-label": "search" }}
		/>
	);
};

export default SearchBar;
